import React, { useCallback, useEffect, useRef, useState } from "react";
import { Col, Row, Button } from "react-bootstrap";
import InputField from "../../../common/InputFieldWithDropDown/InputField";
import { useMyContext } from "../../../myContext";
import { generateDirectQuote } from "../../../api";
import { addCommasInPrice, decimalAdjust, inputAmount } from "../../../utils";
import indiaflag from "../../../public/assets/inflag.svg";
import styles from "./firstSection.module.css";
import InfoBox from "../../../common/InfoBox/InfoBox";
import arriveIcon from "../../../public/assets/firstsecarrive.svg";
import infoicon from "../../../public/assets/infoicongray.svg";
import downwardicon from "../../../public/assets/downwardicon.svg";
import upwaredicon from "../../../public/assets/upwaredicon.svg";
import SideModal from "../SideModal/SideModal";
import { useNavigate } from "react-router";
import { defaultCurrency } from "../../../constant";

function CalculatorBox() {
  const [transferFee, setTransferFee] = useState("--");
  const [AmountConversion, setAmountConversion] = useState("--");
  const [finalAmount, setFinalAmount] = useState("--");
  const [tcs, setTcs] = useState("--");
  const [gst, setGst] = useState("--");
  const [gatewayFees, setGatewayFees] = useState("--");
  const [ForexRate, setForexRate] = useState("--");
  const [totalEstTaxes, setTotalEstTaxes] = useState("--");
  const [amount, setAmount] = useState("10000");
  const [currency, setCurrency] = useState(defaultCurrency);
  const { planId, partnerCode } = useMyContext();
  const [paddingRight, setPaddingRight] = useState("10px");
  const [showDropdown, setDropDown] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { themeColor } = useMyContext();
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const handleClickOutside = useCallback((event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropDown(false);
    }
  }, []);

  useEffect(() => {
    const updatePaddingSettings = () => {
      if (window.innerWidth < 600) {
        setPaddingRight("0px");
      }
    };
    updatePaddingSettings();
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  const generateQuoteApi = () => {
    const body = {
      amount: amount,
      fromCurrency: "INR",
      toCurrency: currency,
      inputCurrency: currency,
      panNo: "CVVPA1327A",
      planCd: planId,
      partnerCd: partnerCode,
    };
    try {
      generateDirectQuote(body).then((res) => {
        if (res.data) {
          if (amount !== "") {
            setTransferFee(() =>
              addCommasInPrice(
                res.data.totalBankCharges + res.data.handlecharge
              )
            );
            const exRate = decimalAdjust("floor", res.data.exRate, -4);
            setForexRate(addCommasInPrice(exRate));
            const convertingAmount = decimalAdjust(
              "floor",
              amount * exRate,
              -1
            );
            setAmountConversion(() => addCommasInPrice(convertingAmount));
            const gstamount = decimalAdjust("floor", res.data.gstAmt, -1);
            setGst(() => addCommasInPrice(gstamount));
            let tcsamount = 0;
            if (amount * exRate <= 700000) {
              setTcs(() => addCommasInPrice(0));
            } else {
              const tcscalculation = amount * exRate - 700000;
              tcsamount = tcscalculation * 0.05;
              setTcs(() => addCommasInPrice(tcsamount));
            }
            setGatewayFees(() => addCommasInPrice(25));
            const totaltaxes = decimalAdjust(
              "floor",
              res.data.totalBankCharges +
                res.data.handlecharge +
                res.data.gstAmt +
                tcsamount +
                25,
              -1
            );
            setTotalEstTaxes(addCommasInPrice(totaltaxes));
            const finalamount = decimalAdjust(
              "floor",
              convertingAmount + totaltaxes,
              -1
            );
            setFinalAmount(() => addCommasInPrice(finalamount));
          } else {
            setTransferFee("--");
            setAmountConversion("--");
            setForexRate("--");
            setAmountConversion("--");
            setFinalAmount("--");
            setTcs("--");
            setGst("--");
            setGatewayFees("--");
            setTotalEstTaxes("--");
          }
        }
      });
    } catch (error) {}
  };

  useEffect(() => {
    if (planId) generateQuoteApi();
  }, [planId]);

  useEffect(() => {
    let timeoutId;

    setTransferFee("--");
    setAmountConversion("--");
    setForexRate("--");
    setAmountConversion("--");
    setFinalAmount("--");
    setTcs("--");
    setGst("--");
    setGatewayFees("--");
    setTotalEstTaxes("--");
    if (amount === "") {
      clearTimeout(timeoutId);
    }

    const generateQuoteWithDebounce = () => {
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        if (amount > 0) generateQuoteApi();
      }, 400);
    };

    generateQuoteWithDebounce();

    return () => {
      clearTimeout(timeoutId);
    };
  }, [amount, currency]);

  useEffect(() => {
    if (amount === "") {
      setTimeout(() => {
        setTransferFee("--");
        setAmountConversion("--");
        setForexRate("--");
        setAmountConversion("--");
        setFinalAmount("--");
        setTcs("--");
        setGst("--");
        setGatewayFees("--");
        setTotalEstTaxes("--");
      }, 1000);
    }
  }, [amount]);

  const handleDropdown = () => {
    setDropDown(!showDropdown);
  };

  return (
    <div className={styles.transactionBox}>
      <Row>
        <InputField
          label={"Recipient Gets"}
          conversionValueButton={defaultCurrency}
          value={amount}
          onChange={(e) => {
            inputAmount(e, setAmount);
          }}
          dropdown={true}
          dropdownType={"HomeScreen"}
          setCurrency={setCurrency}
        />
      </Row>
      <Row className={styles.Box1}>
        <Col
          xl={8}
          lg={8}
          md={6}
          sm={8}
          xs={8}
          className={styles.transactionCol}
          style={{ justifyContent: "start" }}
        >
          Lowest Exchange Rate
          {"  "}
          <InfoBox
            content={
              "Lowest Forex Markup for the currency as negotiated with our Authorised Dealer"
            }
            show={false}
            image={infoicon}
          />{" "}
        </Col>
        <Col
          xl={4}
          lg={4}
          md={6}
          sm={4}
          xs={4}
          className={styles.transactionCol}
          style={{ justifyContent: "end", paddingRight: paddingRight }}
        >
          {ForexRate} {ForexRate !== "--" && "INR"}
        </Col>
      </Row>
      <hr className={styles.horizontalline} />
      <Row className={styles.Box2}>
        <Col
          xl={8}
          lg={8}
          md={6}
          sm={8}
          xs={8}
          className={styles.transactionCol}
          style={{ justifyContent: "start" }}
        >
          Total amount we’ll convert
        </Col>
        <Col
          xl={4}
          lg={4}
          md={6}
          sm={4}
          xs={4}
          className={styles.transactionCol}
          style={{ justifyContent: "end", paddingRight: paddingRight }}
        >
          {AmountConversion} {AmountConversion !== "--" && "INR"}
        </Col>
      </Row>
      <hr className={styles.horizontalline} />
      <Row className={styles.Box1}>
        <Col
          xl={8}
          lg={8}
          md={6}
          sm={8}
          xs={8}
          className={styles.transactionCol}
          style={{ justifyContent: "start" }}
        >
          Est. Taxes & Fees
        </Col>
        <Col
          xl={4}
          lg={4}
          md={6}
          sm={4}
          xs={4}
          className={styles.transactionCol}
          style={{
            justifyContent: "end",
            position: "relative",
            paddingRight: paddingRight,
          }}
        >
          {totalEstTaxes}{" "}
          {totalEstTaxes !== "--" && (
            <>
              INR
              <img
                ref={dropdownRef}
                src={showDropdown ? upwaredicon : downwardicon}
                style={{
                  marginLeft: "10px",
                  height: "6px",
                  width: "12px",
                  cursor: "pointer",
                }}
                onClick={handleDropdown}
                alt=""
              ></img>{" "}
            </>
          )}
          {showDropdown && (
            <div className={styles.dropdownDiv}>
              <Row>
                <Col
                  md={8}
                  sm={8}
                  xs={8}
                  className={styles.dropdownCol}
                  style={{ paddingRight: "0px" }}
                >
                  Our Fees
                </Col>
                <Col
                  md={4}
                  sm={4}
                  xs={4}
                  className={styles.dropdownblueCol}
                  style={{ paddingLeft: "0px" }}
                >
                  <s
                    className={styles.dropdownCol}
                    style={{ color: "black", marginRight: "4px" }}
                  >
                    500
                  </s>{" "}
                  0
                </Col>
              </Row>
              <hr style={{ width: "100%", margin: "4px 0px" }} />
              <Row>
                <Col
                  md={8}
                  sm={8}
                  xs={8}
                  className={styles.dropdownCol}
                  style={{ paddingRight: "0px" }}
                >
                  Bank Transfer Fees
                </Col>
                <Col
                  md={4}
                  sm={4}
                  xs={4}
                  className={styles.dropdownCol}
                  style={{ justifyContent: "end", paddingLeft: "0px" }}
                >
                  {transferFee}
                </Col>
              </Row>
              <hr style={{ width: "100%", margin: "4px 0px" }} />
              <Row>
                <Col
                  md={8}
                  sm={8}
                  xs={8}
                  className={styles.dropdownCol}
                  style={{ paddingRight: "0px" }}
                >
                  TCS (Est.){" "}
                </Col>
                <Col
                  md={4}
                  sm={4}
                  xs={4}
                  className={styles.dropdownCol}
                  style={{ justifyContent: "end", paddingLeft: "0px" }}
                >
                  {tcs}
                </Col>
              </Row>
              <hr style={{ width: "100%", margin: "4px 0px" }} />
              <Row>
                <Col
                  sm={8}
                  xs={8}
                  className={styles.dropdownCol}
                  style={{ paddingRight: "0px" }}
                >
                  GST (Est.)
                </Col>
                <Col
                  md={4}
                  sm={4}
                  xs={4}
                  className={styles.dropdownCol}
                  style={{ justifyContent: "end", paddingLeft: "0px" }}
                >
                  {gst}
                </Col>
              </Row>
              <hr style={{ width: "100%", margin: "4px 0px" }} />
              <Row>
                <Col
                  md={9}
                  sm={9}
                  xs={9}
                  style={{ paddingRight: "0px" }}
                  className={styles.dropdownCol}
                >
                  Payment Gateway Fees (Max.)
                </Col>
                <Col
                  md={3}
                  sm={3}
                  xs={3}
                  className={styles.dropdownCol}
                  style={{ justifyContent: "end", paddingLeft: "0px" }}
                >
                  {gatewayFees}
                </Col>
              </Row>
            </div>
          )}
        </Col>
      </Row>
      <hr className={styles.horizontalline} />
      <Row style={{ marginTop: "4px" }}>
        <InputField
          label={"You Pay"}
          conversionValueButton={"INR"}
          disabled={true}
          value={finalAmount}
          inputSize="home"
          image={indiaflag}
        />
      </Row>
      <Row className={styles.arrivetext}>
        <img src={arriveIcon} alt="" className={styles.arriveImage}></img>
        Should arrive in{" "}
        <strong style={{ width: "fit-content", padding: "0px 4px" }}>
          48 hours
        </strong>
      </Row>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button
          className={styles.getStartedButton}
          style={{ backgroundColor: themeColor, borderColor: themeColor }}
          onClick={() => {
            navigate("/login");
          }}
        >
          Get Started
        </Button>
      </div>
      <div
        className={styles.comparediv}
        onClick={() => {
          setShowModal(true);
        }}
      >
        How we compare
      </div>
      <SideModal showModal={showModal} setShowModal={setShowModal} />
    </div>
  );
}

export default CalculatorBox;
